/** Stable color palette for distinguishing services on calendars/charts. */
export const SERVICE_COLOR_PALETTE = [
  {
    bg: "bg-sky-100 dark:bg-sky-950",
    text: "text-sky-800 dark:text-sky-300",
    border: "border-sky-200 dark:border-sky-800",
    dot: "bg-sky-500",
    hex: "#0ea5e9",
  },
  {
    bg: "bg-emerald-100 dark:bg-emerald-950",
    text: "text-emerald-800 dark:text-emerald-300",
    border: "border-emerald-200 dark:border-emerald-800",
    dot: "bg-emerald-500",
    hex: "#10b981",
  },
  {
    bg: "bg-amber-100 dark:bg-amber-950",
    text: "text-amber-800 dark:text-amber-300",
    border: "border-amber-200 dark:border-amber-800",
    dot: "bg-amber-500",
    hex: "#f59e0b",
  },
  {
    bg: "bg-rose-100 dark:bg-rose-950",
    text: "text-rose-800 dark:text-rose-300",
    border: "border-rose-200 dark:border-rose-800",
    dot: "bg-rose-500",
    hex: "#f43f5e",
  },
  {
    bg: "bg-violet-100 dark:bg-violet-950",
    text: "text-violet-800 dark:text-violet-300",
    border: "border-violet-200 dark:border-violet-800",
    dot: "bg-violet-500",
    hex: "#8b5cf6",
  },
  {
    bg: "bg-pink-100 dark:bg-pink-950",
    text: "text-pink-800 dark:text-pink-300",
    border: "border-pink-200 dark:border-pink-800",
    dot: "bg-pink-500",
    hex: "#ec4899",
  },
  {
    bg: "bg-cyan-100 dark:bg-cyan-950",
    text: "text-cyan-800 dark:text-cyan-300",
    border: "border-cyan-200 dark:border-cyan-800",
    dot: "bg-cyan-500",
    hex: "#06b6d4",
  },
  {
    bg: "bg-lime-100 dark:bg-lime-950",
    text: "text-lime-800 dark:text-lime-300",
    border: "border-lime-200 dark:border-lime-800",
    dot: "bg-lime-500",
    hex: "#84cc16",
  },
] as const;

export type ServiceColor = (typeof SERVICE_COLOR_PALETTE)[number];

export function getServiceColorByIndex(index: number): ServiceColor {
  return SERVICE_COLOR_PALETTE[index % SERVICE_COLOR_PALETTE.length];
}

/** Assign a stable color index per service id (sorted by first appearance or id). */
export function buildServiceColorMap(
  serviceIds: Array<number | string>
): Map<number, ServiceColor> {
  const unique = Array.from(
    new Set(
      serviceIds
        .map((id) => Number(id))
        .filter((id) => Number.isFinite(id) && id > 0)
    )
  ).sort((a, b) => a - b);

  const map = new Map<number, ServiceColor>();
  unique.forEach((id, index) => {
    map.set(id, getServiceColorByIndex(index));
  });
  return map;
}
